import { sportConstants } from '../_constants';
import { sportService } from '../_services';

export const sportActions = {
    getAll,
		selectSport
};

function getAll(token) {
    return dispatch => {
        dispatch(request());

        sportService.getAll(token)
            .then(
                sports => dispatch(success(sports)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: sportConstants.GET_SPORTS_REQUEST } }
    function success(sports) { return { type: sportConstants.GET_SPORTS_SUCCESS, sports } }
    function failure(error) { return { type: sportConstants.GET_SPORTS_FAILURE, error } }
}

function selectSport(sport) {
	return {
		type: sportConstants.SPORT_SELECTED,
		sport
	}
}



// WEBPACK FOOTER //
// ./src/_actions/sports.js